import React from 'react';
import store from '@apply/adminStore';
import { Navigate } from 'react-router-dom';
import { Header, MenuItemOption } from '../../common_v2/components/Header';
import { Footer } from '../../common_v2/components/Footer';
import { BrokerNotYetActivatedPanel } from './components/BrokerNotYetActivatedPanel';
import { BrokerActivatedPanel } from './components/brokerActivatedPanel/BrokerActivatedPanel';
import { useAppContext } from '../../../AppContext';

export const ReferralSummaryV2: React.FC = () => {
    const { user } = store.getState();
    const { refreshBroker } = useAppContext();

    if (!user) {
        return (
            <Navigate
                to='/login'
                replace
            />
        );
    }

    if (user && user.requiresESign) {
        return (
            <Navigate
                to='/broker/signagreement'
                replace
            />
        );
    }

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.Home} />
                <main>
                    <>
                        {user?.broker?.activated ? (
                            <BrokerActivatedPanel />
                        ) : (
                            <BrokerNotYetActivatedPanel onRefreshUser={refreshBroker} />
                        )}
                    </>
                </main>
            </div>
            <Footer showAuthenticatedFooter={true} />
        </>
    );
};
